/**
 * パスワードバリデーション共通ユーティリティ
 *
 * バックエンドと同じルールをフロントエンドでも適用:
 * - 8文字以上
 * - 英字（a-zA-Z）を1文字以上
 * - 数字（0-9）を1文字以上
 */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES = [
    { test: (pw) => pw.length >= PASSWORD_MIN_LENGTH, label: `${PASSWORD_MIN_LENGTH}文字以上` },
    { test: (pw) => /[a-zA-Z]/.test(pw), label: '英字を1文字以上' },
    { test: (pw) => /[0-9]/.test(pw), label: '数字を1文字以上' },
];

export const PASSWORD_RULES_TEXT = `パスワードは${PASSWORD_MIN_LENGTH}文字以上で、英字と数字をそれぞれ1文字以上含めてください。`;

/**
 * パスワードが全てのルールを満たしているかチェック
 * @param {string} password
 * @returns {boolean}
 */
export const isPasswordValid = (password) => {
    return PASSWORD_RULES.every((rule) => rule.test(password));
};
